module.exports = __webpack_public_path__ + "img/registerlogin.8ed80660.png";